import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import TextField from '@material-ui/core/TextField';
import CancelIcon from '@material-ui/icons/Cancel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Api from '../../Api/Api';
import { Chip, makeStyles, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import UserProfile from '../../Common/UserProfile';
import { UtilsMaterial } from '../../../helpers/utilsMaterial';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Row, Col } from 'react-bootstrap';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { CirclePicker } from 'react-color';
import UtilsForm from '../../Common/UtilsForm';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  updateApplicantTags as updateStoreApplicantTags,
  fetchApplicantTagsByIds,
  ensureApplicantTags
} from '../../Api/EventsStream';
import * as materialColors from 'material-colors';
import AddTagIcon from '../Detail2/Tags/AddTagIcon';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

const messages = defineMessages({
  button_createLabel: {
    id: 'ApplicantTagsSelection.button_createLabel',
    defaultMessage: 'Create Tag'
  },
  tagPlaceholder: {
    id: 'ApplicantTagsSelection.tagPlaceholder',
    defaultMessage: 'Select Tag'
  },
  add_modalTitle: {
    id: 'ApplicantTagsSelection.add_modalTitle',
    defaultMessage: 'New Candidate Tag'
  },
  msg_chooseTagColor: {
    id: 'ApplicantTagsSelection.msg_chooseTagColor',
    defaultMessage: 'Please, choose the tag color'
  }
});

const useStyles = (theme) => ({
  root: {
    minWidth: 280,
    display: 'flex',
    textAlign: 'left',
    paddingBottom: 8,
    fontWeight: 600,
    alignItems: 'center',
    '& svg': {
      marginLeft: '.5rem',
      width: '1rem',
      height: '1rem'
    }
  },
  tagContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  inputBase: {
    minWidth: 360,
    '& input::placeholder': {
      fontSize: '.9rem',
      color: theme.palette.common.black
    }
  },
  inputBaseRead: {
    width: '100%',
    '& input::placeholder': {
      fontSize: '.9rem',
      color: theme.palette.common.black
    }
  },
  paper: {
    margin: 0,
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    paddingRight: 0
  },
  option: {
    display: 'flex',
    alignItems: 'center'
  },
  tagIcon: {
    fontSize: '1.25rem'
  },
  printChip: {
    '@media print': {
      color: theme.palette.gray.darkerMedium,
      backgroundColor: `${theme.palette.gray.darkerMedium}10`,
      borderColor: theme.palette.gray.darkerMedium,
      '& .MuiChip-icon': {
        color: theme.palette.gray.darkerMedium
      }
    }
  }
});

const chipStyles = makeStyles((theme) => ({
  root: {
    color: (props) => materialColors[UtilsMaterial.getMaterialColorByHex(props.color).color2][900],
    fontSize: (props) => (props.displaySize === 'small' ? '0.6rem' : '0.75rem'),
    fontWeight: 400,
    padding: (props) => props.displaySize === 'small' && '0 4px'
  }
}));

const CssChip = (props) => {
  const { color, displaySize, ...other } = props;

  const classes = chipStyles({ color, displaySize });

  const colorKey = UtilsMaterial.getMaterialColorByHex(color).color2;
  const bgColor = materialColors[colorKey][100];

  return (
    <Chip
      style={{
        backgroundColor: bgColor,
        borderColor: materialColors[colorKey][500],
        borderRadius: '4px',
        maxHeight: `${displaySize === 'small' ? '1.25rem' : '1.5rem'}`,
        maxWidth: `${displaySize === 'small' && '5rem'}`
      }}
      classes={{ label: classes.root }}
      className={classes.printChip}
      {...other}
    />
  );
};

const textFieldStyles = (theme) => ({
  root: {
    '& label.Mui-focused': {
      borderBottom: `1px solid ${theme.palette.gray.main}`
    },
    '& .MuiInput-underline:after': {
      border: 'none'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none'
      },
      '&:hover fieldset': {
        border: 'none'
      },
      '&.Mui-focused fieldset': {
        border: 'none'
      }
    }
  }
});

const CssTextField = withStyles(textFieldStyles)(TextField);

const EllipsisText = (props) => {
  const { children } = props;

  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '6rem'
      }}
    >
      {children}
    </div>
  );
};

const EDIT_ACTION = {
  ADD: 'ADD',
  REMOVE: 'REMOVE'
};

class ApplicantTagsSelection extends Component {
  constructor(props) {
    super(props);

    this._searchTimeout = 0;
    this._tagsById = this._buildTagsById(this.props.tags);

    this.state = {
      // Props from parent
      canChangeTags: this.props.canChangeTags,
      applicant_id: this.props.applicant_id,
      applicantTags: this.props.applicantTags ? this.props.applicantTags : [],
      // Props from store
      tagsList: this.props.tags ? this.props.tags : [],
      // Internal state
      user_id: UserProfile.getId(),
      activeTagsList: [],
      anchorEl: null,
      value: [],
      id: null,
      active: true,
      edit_name: '',
      edit_color: '',
      fullColor: {},
      editingApplicantTags: [],
      tagsExpanded: false,
      isOpen: false,
      editModal: false,
      _loading: false,
      _submiting: false
    };
  }

  _buildTagsById = (tags) => {
    const map = new Map();

    if (Array.isArray(tags)) {
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];

        if (tag && tag.id != null) map.set(tag.id, tag);
      }
    }

    return map;
  };

  _resolveApplicantTagObjs = (applicantTagIds, tagsById) => {
    const out = [];
    if (!Array.isArray(applicantTagIds) || !tagsById || tagsById.size === 0) return out;

    for (let i = 0; i < applicantTagIds.length; i++) {
      const hit = tagsById.get(applicantTagIds[i]);
      if (hit) out.push(hit);
    }

    return out;
  };

  componentDidMount() {
    this._isMounted = true;
    if (this.state.canChangeTags && (!this.state.tagsList || this.state.tagsList.length === 0)) {
      this.ensureCatalogLoaded();
    } else {
      this.getInitialApplicantTags();
    }
  }

  ensureCatalogLoaded = () => {
    if (this._fetchingCatalog) return;
    this._fetchingCatalog = true;

    ensureApplicantTags()
      .then((tags) => {
        if (!this._isMounted) return;

        const tagsList = Array.isArray(tags) ? tags : [];
        this._tagsById = this._buildTagsById(tagsList);
        this.setState({ tagsList }, () => this.getInitialApplicantTags());
      })
      .catch(() => {})
      .finally(() => {
        this._fetchingCatalog = false;
      });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tags !== this.props.tags) {
      this._tagsById = this._buildTagsById(this.props.tags);
      this.setState(
        {
          tagsList: this.props.tags || []
        },
        () => this.getInitialApplicantTags()
      );
    }

    if (prevProps.applicantTags !== this.props.applicantTags) {
      this.setState(
        {
          applicantTags: this.props.applicantTags
        },
        () => this.getInitialApplicantTags()
      );
    }
  }

  getInitialApplicantTags = () => {
    const applicantTags = this.state.applicantTags;
    const tagsList = this.state.tagsList;
    const canChangeTags = this.state.canChangeTags;

    if (canChangeTags && (!tagsList || tagsList.length === 0)) {
      this.ensureCatalogLoaded();
      return;
    }

    if (applicantTags && applicantTags.length > 0 && (!tagsList || tagsList.length === 0)) {
      if (this._fetchingRowTags) return;

      this._fetchingRowTags = true;
      fetchApplicantTagsByIds(applicantTags)
        .then((objs) => {
          if (!this._isMounted) return;

          this._tagsById = this._buildTagsById([
            ...Array.from(this._tagsById ? this._tagsById.values() : []),
            ...objs
          ]);
          this.setState({ editingApplicantTags: objs, activeTagsList: [] });
        })
        .catch(() => {})
        .finally(() => {
          this._fetchingRowTags = false;
        });

      return;
    }

    const editingApplicantTags = this._resolveApplicantTagObjs(applicantTags, this._tagsById);

    if (!canChangeTags) {
      this.setState({ editingApplicantTags, activeTagsList: [] });
      return;
    }

    this.setState(
      {
        editingApplicantTags: editingApplicantTags
      },
      () => this.getActiveTags()
    );
  };

  getApplicantTags = () => {
    this.getInitialApplicantTags();
  };

  getActiveTags = () => {
    if (!this.state.canChangeTags) return;

    const tagsList = this.state.tagsList;
    let activeTagsList = [];

    if (tagsList.length > 0) {
      activeTagsList = tagsList.filter((tag) => tag.active);
    }

    this.setState({
      activeTagsList: activeTagsList
    });
  };

  updateApplicantTags = (action, tagId) => {
    let api = new Api();
    const applicant_id = this.state.applicant_id;
    let param = {
      applicant_id: applicant_id,
      tag_id: tagId,
      action: action
    };

    api.post('Applicants/update-tag', param, (status, data) => {
      if (status >= 400) {
        console.log('Error on update');
      }
    });
  };

  handleChange = (newValue) => {
    const editingApplicantTags = this.state.editingApplicantTags;
    let updatedTag;

    if (newValue.length > editingApplicantTags.length) {
      updatedTag = newValue.filter((tag) => !editingApplicantTags.includes(tag));

      this.setState(
        {
          editingApplicantTags: newValue
        },
        () => {
          if (updatedTag) {
            this.updateApplicantTags(EDIT_ACTION.ADD, updatedTag[0].id);
          }
        }
      );
    } else {
      updatedTag = editingApplicantTags.filter((tag) => !newValue.includes(tag));
      this.setState(
        {
          editingApplicantTags: newValue
        },
        () => {
          if (updatedTag) {
            this.updateApplicantTags(EDIT_ACTION.REMOVE, updatedTag[0].id);
          }
        }
      );
    }
  };

  handleChangeTag = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  };

  handleOpenAutocomplete = (value) => {
    if (value && (!this.state.tagsList || this.state.tagsList.length === 0)) {
      this.ensureCatalogLoaded();
    }

    this.setState({
      isOpen: value
    });
  };

  handleAddTag = () => {
    this.setState({
      editModal: true
    });
  };

  handleAddTagClose = () => {
    this.setState({
      editModal: false
    });
  };

  handleChangeColorPicker = (color) => {
    this.setState({ edit_color: color.hex });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.state.edit_color === null || this.state.edit_color === '') {
      window.swal({
        type: 'info',
        title: '',
        text: this.props.intl.formatMessage(messages.msg_chooseTagColor),
        closeOnConfirm: true
      });
    } else {
      const tag = {
        account_id: this.props.accountInfo.accountInfo.account_id,
        user_id: UtilsForm.replaceToNull(this.state.user_id),
        active: UtilsForm.replaceToNull(this.state.active),
        name: UtilsForm.replaceToNull(this.state.edit_name),
        color: UtilsForm.replaceToNull(this.state.edit_color)
      };

      this.addTag(tag);
    }
  };

  addTag = (tag) => {
    this.setState(
      {
        _submiting: true
      },
      () => {
        let api = new Api();
        let editingApplicantTags = [...this.state.editingApplicantTags];
        api.post('ApplicantTags', tag, (status, data) => {
          if (status >= 200) {
            const newTag = data;
            editingApplicantTags.push(newTag);
            this.setState(
              {
                _submiting: false,
                editModal: false
              },
              () => {
                updateStoreApplicantTags()
                  .then((res) => {
                    if (newTag && newTag.id) {
                      this.handleChange(editingApplicantTags);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            );
          } else {
            console.log('Error on post');
          }
        });
      }
    );
  };

  render() {
    const { classes } = this.props;
    const activeTagsList = this.state.activeTagsList;
    const editingApplicantTags = this.state.editingApplicantTags;
    const canChangeTags = this.state.canChangeTags;
    const isOpen = this.state.isOpen;

    const displayTagsSelection = () => {
      if (!canChangeTags && editingApplicantTags.length === 0) {
        return null;
      }

      if (
        UserProfile.isAdmin() ||
        UserProfile.isHRManager() ||
        UserProfile.isRecruiter() ||
        UserProfile.isJobManager()
      ) {
        return (
          <>
            <Box className={classes.tagContainer}>
              {canChangeTags && (
                <>
                  <Box style={{ marginRight: '1.25rem' }}>
                    <AddTagIcon />
                  </Box>
                  {(UserProfile.isAdmin() || UserProfile.isTagUser()) && (
                    <Box style={{ marginRight: '0.5rem' }}>
                      <Tooltip title={this.props.intl.formatMessage(messages.button_createLabel)}>
                        <IconButton
                          className={classes.tagIcon}
                          style={{ padding: 0 }}
                          edge="start"
                          color="inherit"
                          onClick={this.handleAddTag}
                        >
                          <AddCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                </>
              )}

              {!canChangeTags ? (
                <Box display="flex" flexWrap="wrap" alignItems="center" style={{ gap: 4 }}>
                  {(this.state.tagsExpanded
                    ? editingApplicantTags
                    : editingApplicantTags.slice(0, 5)
                  ).map((option, index) => (
                    <Tooltip title={option.name} key={option.id || index}>
                      <div>
                        <CssChip
                          color={option.color}
                          displaySize="small"
                          size="small"
                          variant="outlined"
                          label={<EllipsisText>{option.name}</EllipsisText>}
                        />
                      </div>
                    </Tooltip>
                  ))}
                  {!this.state.tagsExpanded && editingApplicantTags.length > 5 ? (
                    <CssChip
                      color="#757575"
                      displaySize="small"
                      size="small"
                      variant="outlined"
                      clickable
                      onClick={() => this.setState({ tagsExpanded: true })}
                      label={'+' + (editingApplicantTags.length - 5)}
                    />
                  ) : null}
                  {this.state.tagsExpanded && editingApplicantTags.length > 5 ? (
                    <CssChip
                      color="#757575"
                      displaySize="small"
                      size="small"
                      variant="outlined"
                      clickable
                      onClick={() => this.setState({ tagsExpanded: false })}
                      label={'−'}
                    />
                  ) : null}
                </Box>
              ) : (
                <Autocomplete
                  disabled={this.state._loading}
                  disableClearable
                  open={canChangeTags && isOpen}
                  id="tags"
                  label="tags"
                  name="tags"
                  fullWidth
                  freeSolo
                  multiple
                  selectOnFocus
                  clearOnBlur
                  filterSelectedOptions
                  limitTags={canChangeTags ? 10 : 5}
                  forcePopupIcon={canChangeTags}
                  onOpen={() => {
                    canChangeTags && this.handleOpenAutocomplete(true);
                  }}
                  onClose={() => {
                    this.handleOpenAutocomplete(false);
                  }}
                  classes={{
                    paper: classes.paper,
                    inputBase: classes.inputBase
                  }}
                  value={editingApplicantTags}
                  options={activeTagsList}
                  getOptionLabel={(option) => option.name}
                  getOptionSelected={(option, value) => option.name === value.name}
                  onChange={(event, newValue) => {
                    this.handleChange(newValue);
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                      return (
                        <Tooltip title={option.name} key={index}>
                          <div>
                            <CssChip
                              color={option.color}
                              displaySize="small"
                              size="small"
                              variant="outlined"
                              label={<EllipsisText>{option.name}</EllipsisText>}
                              {...getTagProps({ index })}
                              deleteIcon={
                                <IconButton
                                  disabled={!canChangeTags}
                                  hidden={!canChangeTags}
                                  size="small"
                                  style={{
                                    color:
                                      materialColors[
                                        UtilsMaterial.getMaterialColorByHex(option.color).color2
                                      ][500]
                                  }}
                                >
                                  {canChangeTags && <CancelIcon style={{ fontSize: '1rem' }} />}
                                </IconButton>
                              }
                            />
                          </div>
                        </Tooltip>
                      );
                    })
                  }
                  disableCloseOnSelect
                  renderOption={(option) => (
                    <>
                      <div className={classes.option}>
                        <span
                          style={{
                            color: `${option.color}`,
                            fontSize: '.75rem',
                            marginRight: '1rem'
                          }}
                        >
                          <LocalOfferIcon />
                        </span>
                        <span>{option.name}</span>
                      </div>
                    </>
                  )}
                  renderInput={(params) => (
                    <CssTextField
                      variant="outlined"
                      className={canChangeTags ? classes.inputBase : classes.inputBaseRead}
                      placeholder={
                        canChangeTags
                          ? this.props.intl.formatMessage(messages.tagPlaceholder)
                          : undefined
                      }
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: !canChangeTags,
                        disableUnderline: true,
                        style: {
                          display: 'flex',
                          alignItems: 'center',
                          padding: '0 1rem 0 0',
                          fontSize: '1rem'
                        }
                      }}
                    />
                  )}
                />
              )}
            </Box>
            <Dialog
              open={this.state.editModal}
              fullWidth={true}
              maxWidth="sm"
              onClose={this.onEditClose}
              className={classes.modal}
            >
              <form id="formEditTag" onSubmit={(e) => this.onSubmit(e)}>
                <DialogTitle>{this.props.intl.formatMessage(messages.add_modalTitle)}</DialogTitle>
                <DialogContent>
                  <Row className={classes.titleRow}>
                    <Col md={8}>
                      <div className="form-group">
                        <TextField
                          id="edit_name"
                          name="edit_name"
                          type="text"
                          value={this.state.edit_name}
                          required={true}
                          fullWidth
                          onChange={this.handleChangeTag}
                          label={
                            <FormattedMessage
                              id="ApplicantTagsSelection.field_name"
                              defaultMessage="Tag name"
                            />
                          }
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.active}
                            onChange={this.handleChangeTag}
                            name="active"
                            color="primary"
                          />
                        }
                        label={
                          <InputLabel className={classes.activeLabel} id="active-label">
                            <FormattedMessage
                              id="ApplicantTagsSelection.field_active"
                              defaultMessage="Active?"
                            />
                          </InputLabel>
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        <Row>
                          <Col md={12}>
                            <InputLabel className={classes.inputLabel} id="select-label">
                              <FormattedMessage
                                id="ApplicantTagsSelection.field_color"
                                defaultMessage="Tag color"
                              />
                            </InputLabel>

                            <CirclePicker
                              width={'100%'}
                              maxWidth="100%"
                              color={this.state.edit_color}
                              colors={UtilsMaterial.getThemeColorsByHue(500)}
                              onChangeComplete={this.handleChangeColorPicker}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button type="button" color="secondary" onClick={this.handleAddTagClose}>
                    <FormattedMessage id="Base.button.cancel" />
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={this.state._submiting || this.state._loading}
                  >
                    <FormattedMessage
                      id="ApplicantTagsSelection.button_saveTag"
                      defaultMessage="Save Tag"
                    />
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
          </>
        );
      } else {
        return null;
      }
    };

    return <>{displayTagsSelection()}</>;
  }
}

ApplicantTagsSelection.propTypes = {
  tags: PropTypes.array,
  accountInfo: PropTypes.object
};

const mapStateToProps = (state) => ({
  tags: state.applicantTags.tags,
  accountInfo: state.accountInfo
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(withStyles(useStyles)(ApplicantTagsSelection)));
